// Copia en memoria de una foto elegida del dispositivo.
// En Android, un archivo elegido de la galeria sigue atado a un acceso del
// sistema que puede dejar de ser valido antes del envio: la vista previa sale
// rota y el fetch del formulario falla con "Failed to fetch". Leer el contenido
// apenas se elige hace que el envio no dependa de ese acceso, y si el archivo no
// se puede leer se descubre en ese momento y no al apretar Verificar.

export function readFileToMemory(file) {
  return new Promise((resolve, reject) => {
    if (!(file instanceof Blob)) {
      reject(new Error("not a file"));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error("read failed"));
    reader.onload = () => {
      const buffer = reader.result;
      if (!buffer || buffer.byteLength === 0) {
        reject(new Error("empty file"));
        return;
      }
      resolve(new File([buffer], file.name || "photo.jpg", { type: file.type }));
    };
    try {
      reader.readAsArrayBuffer(file);
    } catch (e) {
      reject(e);
    }
  });
}
